import { render, staticRenderFns } from "./ActCar.vue?vue&type=template&id=71827702&scoped=true&"
import script from "./ActCar.vue?vue&type=script&lang=js&"
export * from "./ActCar.vue?vue&type=script&lang=js&"
import style0 from "./ActCar.vue?vue&type=style&index=0&id=71827702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71827702",
  null
  
)

export default component.exports